import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/auth-context';
import MainLayout from './layout';
import Home from './layout/Home';
import ProductDetail from './page/detail';
import LoginPage from './page/login';
import ProductDetailPage from './page/detailPage';
import ProductDetailPageTrans from './page/detailProductPage';
import { StoreConfig } from './tenant';

type AppProps = {
  store: StoreConfig | null;
};

function App({ store }: AppProps) {
  return (
    <Router>
      <AuthProvider>
        <MainLayout>
          <div
            style={{
              backgroundColor: '#f4f4f5',
              borderBottom: '1px solid #e4e4e7',
              padding: '8px 12px',
              textAlign: 'center',
              fontSize: '14px',
            }}
          >
          </div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-tiet-san-pham/:id" element={<ProductDetail />} />
            <Route path="/danh-muc-san-pham" element={<ProductDetailPage />} />
            <Route path="/dang-nhap" element={<LoginPage />} />
            <Route path="/danh-muc-san-pham/:slug/:id" element={<ProductDetailPageTrans />} />
          </Routes>
        </MainLayout>
      </AuthProvider>
    </Router>
  );
}

export default App;
